import React from 'react';
import SvgIcon from './SvgIcon';

const History = props => (
    <SvgIcon {...props}>
        <g stroke="none">
            <path d="M7.385 3.692V8c0 .34.275.615.615.615h4.308v-1.23H8.615V3.692h-1.23z" />
            <path d="M7.997 0A8.007 8.007 0 000 8h1.333a6.674 6.674 0 0112.645-2.992 6.679 6.679 0 01-1.695 8.115 6.673 6.673 0 01-8.284.21l1.2-1.6-4.8-.266L2 16l1.2-1.604a7.995 7.995 0 009.436.125A8.002 8.002 0 007.997 0z" />
        </g>
    </SvgIcon>
);

History.displayName = 'HistoryIcon';

export default History;
